/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  Checkbox,
  Dialog,
  DialogActions,
  FormControl,
  FormControlLabel,
  Grid,
  InputAdornment,
  MenuItem,
  Modal,
  OutlinedInput,
  Select,
  TextField,
  Tooltip,
  Typography
} from '@mui/material';
import { makeStyles } from '@material-ui/styles';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { InputLabel } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { formatDateForInput } from 'utilities/common';
import { COLOR_PRIMARY, COLOR_SECONDARY, COLOR_WARNING } from 'styles/theme';
import { EXPENSES_BATCH_TYPES, ZERO_GUID } from 'modules/enumerations/enumerationIds';
import { isIdEqual } from 'modules/enumerations/enumerationHelpers';
import { INTERNATIONAL_VOUCHER_TYPE_ID, USD_CURRENCY_ID, TRACK_VOUCHER_TYPE_ID, FEE_VOUCHER_TYPE_ID } from '../voucherConstants';
// import { Permissions } from 'modules/layout/permissions';
import { hasPermission } from 'modules/layout/permissionService';

const useStyles = makeStyles(theme => ({
  card: { width: '100%', flexGrow: 1, flexDirection: 'row', justifyContent: 'space-between' },
  cardContainer: { maxWidth: '100% !important', display: 'flex', flexDirection: 'row', justifyContent: 'space-between' },
  iconRow: { display: 'flex', flexDirection: 'row' },
  cardDisplayContent: {
    maxWidth: '100% !important',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    margin: '10px'
  },
  mb2: { marginBottom: '4px', marginRight: '16px' }
}));

const VoucherInfoCard = props => {
  const {
    voucherInfo,
    isReadOnly,
    updateVoucherInfo,
    voucherTypes = [],
    notPayables = [],
    currencies = [],
    payToVendor,
    terms,
    banks = [],
    bankPaymentMethodTypesEnums = []
  } = props;

  const classes = useStyles();
  const theme = createTheme({ palette: { primary: COLOR_PRIMARY, secondary: COLOR_SECONDARY, warning: COLOR_WARNING } });

  const vi = voucherInfo?.voucherInformation ?? {};

  const isInternationalVoucher = isIdEqual(vi.voucherTypeId, INTERNATIONAL_VOUCHER_TYPE_ID);
  const isTrackVoucher = isIdEqual(vi.voucherTypeId, TRACK_VOUCHER_TYPE_ID);
  const isFeeVoucher = isIdEqual(vi.voucherTypeId, FEE_VOUCHER_TYPE_ID);

  const hasReceiptCurrency = vi.receiptCurrencyId && !isIdEqual(vi.receiptCurrencyId, ZERO_GUID);

  const hasPayInCurrency = vi.payInCurrencyId && !isIdEqual(vi.payInCurrencyId, ZERO_GUID);

  const receiptCurrencyIsUsd = hasReceiptCurrency && isIdEqual(vi.receiptCurrencyId, USD_CURRENCY_ID);

  const payInCurrencyIsUsd = hasPayInCurrency && isIdEqual(vi.payInCurrencyId, USD_CURRENCY_ID);

  const requiresVoucherTypeChange = isInternationalVoucher && receiptCurrencyIsUsd && payInCurrencyIsUsd;

  const showPayInToUsdConversion = isInternationalVoucher && hasPayInCurrency && !payInCurrencyIsUsd;

  const canEditPayrollDate = !isReadOnly && hasPermission('Finance.Vouchers.PayrollDate.Edit');

  const banking = voucherInfo?.bankingInformation ?? {};
  const [showCurrencyModal, setShowCurrencyModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [onHoldReasonDraft, setOnHoldReasonDraft] = useState(vi.onHoldReason || '');
  const [isRushPaymentModalOpen, setIsRushPaymentModalOpen] = useState(false);

  const todaysDate = formatDateForInput(new Date().toISOString());

  const batchOnHoldId = EXPENSES_BATCH_TYPES.ON_HOLD;

  const currencyLabel = id => {
    if (!id || isIdEqual(id, ZERO_GUID)) {
      return '';
    }

    return currencies.find(c => isIdEqual(c.id, id))?.code || '';
  };
  const currencyFull = id => (currencies.find(c => String(c.id) === String(id)) || {}).title || '';

  const patchVI = (changes = {}) => {
    if (isReadOnly) return;
    updateVoucherInfo({
      ...voucherInfo,
      voucherInformation: {
        ...(voucherInfo?.voucherInformation ?? {}),
        ...changes
      }
    });
  };

  const patchBanking = changes => {
    if (isReadOnly) return;
    updateVoucherInfo({
      ...voucherInfo,
      bankingInformation: {
        voucherBankingId: banking?.voucherBankingId ?? null,
        voucherId: vi?.voucherId ?? banking?.voucherId ?? null,
        bankId: banking?.bankId === '' ? null : banking?.bankId,
        ...(voucherInfo?.bankingInformation ?? {}),
        ...changes
      }
    });
  };
  const calcualteDueDate = invoiceDate => {
    if (terms && terms !== '' && terms !== 'None') {
      if (terms === 'NET 0') {
      } else if (terms === 'NET 1') {
        invoiceDate.setDate(invoiceDate.getDate() + 1);
      } else if (terms === 'NET 5') {
        invoiceDate.setDate(invoiceDate.getDate() + 5);
      } else if (terms === 'NET 7') {
        invoiceDate.setDate(invoiceDate.getDate() + 7);
      } else if (terms === 'NET 10') {
        invoiceDate.setDate(invoiceDate.getDate() + 10);
      } else if (terms === 'NET 15') {
        invoiceDate.setDate(invoiceDate.getDate() + 15);
      } else if (terms === 'NET 30') {
        invoiceDate.setDate(invoiceDate.getDate() + 30);
      }
      return invoiceDate;
    } else {
      return '';
    }
  };

  const handleInvoiceChange = e => {
    const invoiceDateValue = e.target.value;
    const baseDate = invoiceDateValue ? new Date(invoiceDateValue) : new Date();
    const dueDate = calcualteDueDate(baseDate);

    if (dueDate !== '') {
      patchVI({ dueDate: dueDate.toISOString(), invoiceDate: invoiceDateValue });
    } else {
      patchVI({ invoiceDate: invoiceDateValue });
    }
  };

  // const handleInvoiceBlur = () => {
  //   if (vi.invoiceDate) return;

  //   const dueDate = calcualteDueDate(new Date());
  //   if (dueDate !== '') {
  //     patchVI({ dueDate: dueDate.toISOString() });
  //   }
  // };

  return (
    <ThemeProvider theme={theme}>
      <Card className={classes.card} sx={{ marginTop: '10px' }}>
        <Box>
          <CardContent className={classes.cardContainer}>
            <div className="row justify-space-between align-center">
              <div className={classes.iconRow}>
                <Tooltip title="Voucher Details" placement="right">
                  <FontAwesomeIcon icon={['fas', 'file-contract']} size="2x" />
                </Tooltip>
                <Typography variant="h5" sx={{ paddingLeft: '20px', fontSize: '1.3125rem', fontWeight: 'bold' }}>
                  Voucher Details
                </Typography>
              </div>
            </div>
          </CardContent>

          <CardContent sx={{ padding: '10px', marginLeft: '10px', paddingTop: '0px' }}>
            <Grid container spacing={1} columns={5}>
              {payToVendor && !isFeeVoucher && (
                <Grid item md={1}>
                  <Box>
                    <InputLabel>Invoice Number *</InputLabel>
                    <TextField
                      required
                      disabled={isReadOnly}
                      value={vi.invoiceNumber || ''}
                      sx={{ maxWidth: '360px' }}
                      onChange={e => patchVI({ invoiceNumber: e.target.value })}
                    />
                  </Box>
                </Grid>
              )}

              <Grid item md={1}>
                <Box>
                  <InputLabel>Entry Date</InputLabel>
                  <TextField
                    disabled={isReadOnly}
                    value={vi.entryDate ? formatDateForInput(vi.entryDate) : todaysDate}
                    sx={{ maxWidth: '360px' }}
                    type="date"
                    InputLabelProps={{ shrink: true }}
                    onChange={e => patchVI({ entryDate: e.target.value })}
                  />
                </Box>
              </Grid>

              <Grid item md={1}>
                <Box>
                  <InputLabel>Voucher Type</InputLabel>
                  <Select
                    value={vi.voucherTypeId || ZERO_GUID}
                    sx={{ maxWidth: '180px', minWidth: '180px' }}
                    disabled={isReadOnly}
                    onChange={e => patchVI({ voucherTypeId: e.target.value })}
                    input={<OutlinedInput labelWidth={100} />}
                  >
                    {voucherTypes.map(opt => (
                      <MenuItem key={opt.id} value={opt.id}>
                        {opt.title}
                      </MenuItem>
                    ))}
                  </Select>
                </Box>
              </Grid>
              {!isFeeVoucher && !isTrackVoucher && (
                <Grid item md={1}>
                  <Box>
                    <InputLabel>Payment Method</InputLabel>
                    <Select
                      value={banking?.bankId ?? ''}
                      onChange={e => patchBanking({ bankId: e.target.value })}
                      disabled={isReadOnly}
                      displayEmpty
                      sx={{ maxWidth: '180px', minWidth: '180px' }}
                      input={<OutlinedInput labelWidth={100} />}
                    >
                      <MenuItem value="" disabled>
                        Select a payment method
                      </MenuItem>
                      {banks.map(b => (
                        <MenuItem key={b.id} value={b.id}>
                          {`${b.displayName} (${bankPaymentMethodTypesEnums.find(p => isIdEqual(p.id, b.paymentTypeId))?.title || ''})`}
                        </MenuItem>
                      ))}
                    </Select>
                  </Box>
                </Grid>
              )}
              <Grid item md={1}>
                <Box>
                  <InputLabel>Amount *</InputLabel>
                  <TextField
                    disabled={isReadOnly}
                    value={vi.amount ?? 0}
                    sx={{ maxWidth: '360px' }}
                    type="number"
                    InputProps={{
                      startAdornment: receiptCurrencyIsUsd ? (
                        <InputAdornment position="start">$</InputAdornment>
                      ) : null
                    }}
                    onChange={e => patchVI({ amount: e.target.value })}
                  />
                </Box>
              </Grid>

              {vi?.shouldDisplayReceiptConvertedAmount && vi.payInConvertedAmount > 0 && (
                <Grid item md={1}>
                  <Box>
                    <InputLabel> {`${currencyLabel(vi.receiptCurrencyId)} -> ${currencyLabel(vi.payInCurrencyId)}`}</InputLabel>
                    <TextField
                      value={vi.payInConvertedAmount ?? 0}
                      sx={{ maxWidth: '360px' }}
                      type="number"
                      InputProps={{
                        startAdornment: payInCurrencyIsUsd ? (
                          <InputAdornment position="start">$</InputAdornment>
                        ) : null
                      }}
                      disabled={true}
                    />
                  </Box>
                </Grid>
              )}

              {vi?.shouldDisplayPayInConvertedAmount && vi.usdConvertedAmount && (
                <Grid item md={1}>
                  <Box>
                    <InputLabel> {`${currencyLabel(vi.payInCurrencyId)} -> USD`}</InputLabel>
                    <TextField
                      value={vi.usdConvertedAmount ?? 0}
                      sx={{ maxWidth: '360px' }}
                      type="number"
                      InputProps={{
                        startAdornment:
                          <InputAdornment position="start">$</InputAdornment>
                      }}
                      disabled={true}
                    />
                  </Box>
                </Grid>
              )}

              <Grid item md={1}>
                <Box sx={{ paddingLeft: '5px', cursor: isReadOnly ? 'default' : 'pointer' }}>
                  <div className={classes.mb2}>
                    <Typography
                      variant="subtitle2"
                      sx={{
                        color: '#777667',
                        fontWeight: 400,
                        fontSize: '1rem'
                      }}
                    >
                      Currency
                    </Typography>
                  </div>

                  <div className={classes.mb2}>
                    <Typography
                      variant="body2"
                      sx={{
                        color: '#41B7C0',
                        fontWeight: 500,
                        fontSize: '1rem',
                        cursor: isReadOnly ? 'default' : 'pointer'
                      }}
                      onClick={() => { if (!isReadOnly) setShowCurrencyModal(true); }}
                    >
                      {`${currencyLabel(vi.receiptCurrencyId) || 'Select'} -> ${currencyLabel(vi.payInCurrencyId) || 'Select'}`}
                    </Typography>
                  </div>

                  {requiresVoucherTypeChange && (
                    <Typography
                      variant="caption"
                      sx={{
                        display: 'block',
                        color: '#d32f2f',
                        maxWidth: '220px'
                      }}
                    >
                      Change the voucher type before saving.
                    </Typography>
                  )}
                </Box>
              </Grid>
              {!isFeeVoucher && (
                <Grid item md={1}>
                  <Box>
                    <InputLabel>Invoice Date</InputLabel>
                    <TextField
                      disabled={isReadOnly}
                      value={vi.invoiceDate ? formatDateForInput(vi.invoiceDate) : ''}
                      sx={{ maxWidth: '360px' }}
                      type="date"
                      InputLabelProps={{ shrink: true }}
                      onChange={e => handleInvoiceChange(e)}
                    //onBlur={handleInvoiceBlur}
                    />
                  </Box>
                </Grid>
              )}
              {!isFeeVoucher && (
                <Grid item md={1}>
                  <Box>
                    <InputLabel>Due Date</InputLabel>
                    <TextField
                      disabled={isReadOnly}
                      value={vi.dueDate ? formatDateForInput(vi.dueDate) : ''}
                      sx={{ maxWidth: '360px' }}
                      type="date"
                      InputLabelProps={{ shrink: true }}
                      onChange={e => patchVI({ dueDate: e.target.value })}
                    />
                  </Box>
                </Grid>
              )}
              <Grid item md={1}>
                <Box>
                  <InputLabel>Payroll Date *</InputLabel>
                  <TextField
                    disabled={!canEditPayrollDate}
                    value={vi.payrollDate ? formatDateForInput(vi.payrollDate) : todaysDate}
                    sx={{ maxWidth: '360px' }}
                    type="date"
                    InputLabelProps={{ shrink: true }}
                    onChange={e => patchVI({ payrollDate: e.target.value })}
                  />
                </Box>
              </Grid>

              {isTrackVoucher && (
                <Grid item md={1}>
                  <Box>
                    <InputLabel>Not Payable</InputLabel>
                    <Select
                      value={vi.notPayableId || ZERO_GUID}
                      sx={{ maxWidth: '180px', minWidth: '180px' }}
                      disabled={isReadOnly}
                      onChange={e => patchVI({ notPayableId: e.target.value })}
                    >
                      {notPayables.map(opt => (
                        <MenuItem key={opt.id} value={opt.id}>
                          {opt.title}
                        </MenuItem>
                      ))}
                    </Select>
                  </Box>
                </Grid>
              )}
              {!isFeeVoucher && (

                <Grid item md={1}>
                  <Box sx={{ paddingTop: '8px' }}>
                    <FormControl>
                      <FormControlLabel
                        label="Rush Payment"
                        control={<Checkbox disabled={isReadOnly} checked={!!vi.isRushPayment} />}
                        onChange={(e, checked) => {
                          if (isReadOnly) return;
                          setIsRushPaymentModalOpen(true);
                          patchVI({ isRushPayment: checked });
                        }}
                      />
                    </FormControl>
                  </Box>
                  <Box sx={{ marginRight: '16px' }}>
                    <FormControl>
                      <FormControlLabel
                        label="On Hold"
                        control={
                          <Checkbox disabled={isReadOnly || !batchOnHoldId} checked={vi.onHoldReason !== '' && vi.onHoldReason !== null} />
                        }
                        onChange={(e, checked) => {
                          if (!batchOnHoldId || isReadOnly) return;
                          if (checked) {
                            setIsModalOpen(true);
                          } else {
                            patchVI({ onHoldReason: '' });
                          }
                        }}
                      />
                    </FormControl>

                    <Modal open={!isReadOnly && isModalOpen} onClose={() => setIsModalOpen(false)}>
                      <Box sx={{ width: 500, p: 3, m: 'auto', mt: '20vh', bgcolor: 'white', borderRadius: 2 }}>
                        <Typography variant="h6" sx={{ mb: 2 }}>
                          Enter On Hold Reason
                        </Typography>
                        <TextField
                          fullWidth
                          multiline
                          rows={4}
                          value={onHoldReasonDraft}
                          disabled={isReadOnly}
                          onChange={e => setOnHoldReasonDraft(e.target.value)}
                          placeholder="Please enter the reason for putting the voucher on hold"
                        />
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                          <Button
                            onClick={() => {
                              setIsModalOpen(false);
                            }}
                          >
                            Cancel
                          </Button>
                          <Button
                            onClick={() => {
                              if (!onHoldReasonDraft.trim()) {
                                alert('On Hold reason is required.');
                                return;
                              }
                              patchVI({ onHoldReason: onHoldReasonDraft });
                              setIsModalOpen(false);
                            }}
                            color="primary"
                            variant="contained"
                          >
                            Save
                          </Button>
                        </Box>
                      </Box>
                    </Modal>
                  </Box>
                </Grid>
              )}
              {!isFeeVoucher && (

                <Grid item md={4}>
                  <Box>
                    <InputLabel>Description</InputLabel>
                    <TextField
                      disabled={isReadOnly}
                      value={vi.description || ''}
                      sx={{ minWidth: '360px', width: '100%' }}
                      onChange={e => patchVI({ description: e.target.value })}
                    />
                  </Box>
                </Grid>
              )}
              <Grid item md={4}>
                <Box>
                  <InputLabel>Internal Notes</InputLabel>
                  <TextField
                    disabled={isReadOnly}
                    value={vi.internalNotes || ''}
                    sx={{ minWidth: '360px', width: '100%' }}
                    onChange={e => patchVI({ internalNotes: e.target.value })}
                  />
                </Box>
              </Grid>
            </Grid>
          </CardContent>
          <Dialog open={!isReadOnly && showCurrencyModal} fullWidth={false} maxWidth="lg">
            <Box sx={{ p: 3 }}>
              <Typography variant="h5">Currency Selection</Typography>
            </Box>

            <Box sx={{ display: 'flex', flexDirection: 'row', p: 2 }}>
              <Box sx={{ mr: 2, mt: 2 }}>
                <Typography variant="body2">Receipt Currency</Typography>
              </Box>

              <Box sx={{ mr: 2 }}>
                <Select
                  value={vi.receiptCurrencyId || ZERO_GUID}
                  sx={{
                    maxWidth: '180px',
                    minWidth: '180px'
                  }}
                  disabled={isReadOnly}
                  onChange={e =>
                    patchVI({
                      receiptCurrencyId: e.target.value
                    })
                  }
                >
                  {currencies.map(opt => (
                    <MenuItem key={opt.id} value={opt.id}>
                      {opt.title} ({opt.code})
                    </MenuItem>
                  ))}
                </Select>
              </Box>

              <Box sx={{ p: 3, pt: 2 }}>
                <Typography variant="body2">{currencyFull(vi.receiptCurrencyId)}</Typography>
              </Box>
            </Box>

            <Box sx={{ display: 'flex', flexDirection: 'row', p: 2 }}>
              <Box sx={{ mr: 2, mt: 2 }}>
                <Typography variant="body2">Pay In Currency</Typography>
              </Box>

              <Box sx={{ mr: 2 }}>
                <Select
                  value={vi.payInCurrencyId || ZERO_GUID}
                  sx={{
                    maxWidth: '180px',
                    minWidth: '180px'
                  }}
                  disabled={isReadOnly}
                  onChange={e =>
                    patchVI({
                      payInCurrencyId: e.target.value
                    })
                  }
                >
                  {currencies.map(opt => (
                    <MenuItem key={opt.id} value={opt.id}>
                      {opt.title} ({opt.code})
                    </MenuItem>
                  ))}
                </Select>
              </Box>

              <Box sx={{ p: 3, pt: 2 }}>
                <Typography variant="body2">{currencyFull(vi.payInCurrencyId)}</Typography>
              </Box>
            </Box>

            <Box sx={{ display: 'flex', flexDirection: 'row', p: 2 }}>
              <Box sx={{ mr: 2, mt: 2 }}>
                <Typography variant="body2">
                  {`${currencyLabel(vi.receiptCurrencyId) || 'Select'} -> ${currencyLabel(vi.payInCurrencyId) || 'Select'}`}
                </Typography>
              </Box>

              <Box sx={{ mr: 2 }}>
                <TextField
                  value={vi.currencyExchangeRate ?? ''}
                  sx={{ maxWidth: '360px' }}
                  type="number"
                  disabled={isReadOnly}
                  inputProps={{
                    min: 0,
                    step: 'any'
                  }}
                  onChange={e =>
                    patchVI({
                      currencyExchangeRate: e.target.value === '' ? null : e.target.value
                    })
                  }
                />
              </Box>
            </Box>

            {showPayInToUsdConversion && (
              <Box sx={{ display: 'flex', flexDirection: 'row', p: 2 }}>
                <Box sx={{ mr: 2, mt: 2 }}>
                  <Typography variant="body2">{`${currencyLabel(vi.payInCurrencyId)} -> USD`}</Typography>
                </Box>

                <Box sx={{ mr: 2 }}>
                  <TextField
                    value={vi.payInToUSDCurrencyExchangeRate ?? ''}
                    sx={{ maxWidth: '360px' }}
                    type="number"
                    disabled={isReadOnly}
                    inputProps={{
                      min: 0,
                      step: 'any'
                    }}
                    onChange={e =>
                      patchVI({
                        payInToUSDCurrencyExchangeRate: e.target.value === '' ? null : e.target.value
                      })
                    }
                  />
                </Box>
              </Box>
            )}

            {requiresVoucherTypeChange && (
              <Box sx={{ px: 2, pb: 2 }}>
                <Typography color="error">
                  Receipt Currency and Pay In Currency are both USD. Change the voucher type from International before saving.
                </Typography>
              </Box>
            )}

            <DialogActions sx={{ p: '1.25rem' }}>
              <Button
                onClick={() => setShowCurrencyModal(false)}
                sx={{
                  color: '#41B7C0',
                  '&:hover': {
                    color: '#3d959c'
                  }
                }}
              >
                Cancel
              </Button>

              <Button
                onClick={() => setShowCurrencyModal(false)}
                color="primary"
                variant="contained"
                sx={{
                  backgroundColor: '#41B7C0',
                  '&:hover': {
                    backgroundColor: '#3d959c'
                  }
                }}
              >
                Set Selection
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog open={!isReadOnly && isRushPaymentModalOpen} fullWidth={false} maxWidth="sm">
            <Box sx={{ p: 3, pt: 2 }}>
              <Typography>Have you received approval for a rush payment?</Typography>
            </Box>
            <DialogActions sx={{ p: '1.25rem' }}>
              <Button
                onClick={() => {
                  setIsRushPaymentModalOpen(false);
                  patchVI({ isRushPayment: false });
                }}
                sx={{ color: '#41B7C0', '&:hover': { color: '#3d959c' } }}
              >
                No
              </Button>
              <Button
                onClick={() => {
                  setIsRushPaymentModalOpen(false);
                  patchVI({ isRushPayment: true });
                }}
                color="primary"
                variant="contained"
                sx={{ backgroundColor: '#41B7C0', '&:hover': { backgroundColor: '#3d959c' } }}
              >
                Yes
              </Button>
            </DialogActions>
          </Dialog>
        </Box>
      </Card>
    </ThemeProvider >
  );
};

export default VoucherInfoCard;
